import React, { useState, useEffect } from 'react';
import { Box, useTheme } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';
import './Layout.css';

const Layout = ({ children }) => {
  const theme = useTheme();
  const [layoutError, setLayoutError] = useState(null);

  useEffect(() => {
    // Error handling for layout initialization
    try {
      // Any layout initialization logic
    } catch (error) {
      console.error('Layout initialization error:', error);
      setLayoutError(error);
    }
  }, []);

  return (
    <Box className="layout">
      <Sidebar />
      <Box 
        component="main" 
        className="main-content"
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100vh',
          width: {
            xs: '100%',
            md: 'calc(100% - 256px)',
          },
          marginLeft: {
            xs: 0,
            md: '256px',
          },
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          p: {
            xs: 2,
            sm: 3,
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default Layout; 